// ORDS Database Race Status - for regatta schedule and results from ORDS
export enum OrdRaceStatusEnum {
    Future = 'Future',
    Postponed = 'Postponed',
    Racing = 'Racing',
    Abandoned = 'Abandoned',
    Terminated = 'Terminated',
    Preparatory = 'Preparatory' // Calculated: 3 minutes before race start
}
